import React, {
    useState, useCallback, useContext
} from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import {
    Loader, FormattedDate, useModal
} from '@jutro/components';
import { ViewModelForm, useDataRefresh } from 'gw-portals-viewmodel-react';
import { ClaimService } from 'gw-capability-claim';
import { TranslatorContext } from '@jutro/locale';
import { useAuthentication } from 'gw-digital-auth-react';
import metadata from './NewServiceClaimSearchAndSelectComponent_AX.metadata.json5';
import styles from './NewServiceClaimSearchAndSelectComponent_AX.module.scss';
import messages from './NewServiceClaimSearchAndSelectComponent_AX.messages';

function NewServiceClaimSearchAndSelectComponentAX(props) {
    const translator = useContext(TranslatorContext);
    const { authHeader } = useAuthentication();
    const { refreshData } = useDataRefresh();
    const [isLoading, setLoadingState] = useState(false);
    
    const {
        setClaimSelected,
        claimSearchDTO,
        onUpdateModel,
        claimSelected
    } = props;
    const {
        showAlert
    } = useModal();
    const handleModelChange = useCallback((newModel) => {
        onUpdateModel(newModel);
        refreshData();
    }, [onUpdateModel, refreshData]);

    const handleResponse = useCallback((response) => {
        if (response === undefined) {
            showAlert({
                status: 'info',
                icon: 'mi-info',
                title: translator(messages.noResults),
                message: translator(messages.noResultsMessage)
            });
        } else {
            setClaimSelected(response);
        }
        refreshData();
    }, [refreshData, setClaimSelected, translator]);

    const searchClaim = useCallback(async (e) => {
        e.preventDefault();
        if (claimSearchDTO.claimNumber.trim() === '') {
            showAlert({
                status: 'error',
                icon: 'mi-error',
                title: translator(messages.error),
                message: translator(messages.errorMessage)
            });
            return;
        }

        setLoadingState(true);

        await ClaimService.getClaimDetailWithOutDocumentsAx(
            claimSearchDTO.claimNumber,
            false,
            authHeader
        ).then(handleResponse)
            .catch((error) => {
                setClaimSelected(undefined);
                if (error.baseError.includes('GW_ENTITY_NOT_FOUND_ERROR')) {
                    showAlert({
                        status: 'info',
                        icon: 'mi-info',
                        title: translator(messages.noResults),
                        message: translator(messages.noResultsMessage)
                    });
                }
            })
            .finally(() => {
                setLoadingState(false);
            });
    }, [authHeader, claimSearchDTO, handleResponse, setClaimSelected, translator]);

    const getDateModified = useCallback((value) => {
        if (typeof value === 'undefined') {
            return '';
        }
        return <FormattedDate value={new Date(value)} format="short" />;
    }, []);

    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }

    const overrides = {
        '@field': {
            labelPosition: 'top'
        },
        resultClaimContainer: {
            visible: claimSelected !== undefined
        },
        lossDateID: {
            value: getDateModified(_.get(claimSelected, 'lossDate'))
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            searchClaim: searchClaim
        }
    };

    return (
        <>
            <ViewModelForm
                uiProps={metadata.componentContent}
                model={claimSearchDTO}
                overrideProps={overrides}
                callbackMap={resolvers.resolveCallbackMap}
                onModelChange={handleModelChange}
            />
            <ViewModelForm
                uiProps={metadata.claimData}
                model={claimSelected}
                overrideProps={overrides}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </>
    );
}

export default withRouter(NewServiceClaimSearchAndSelectComponentAX);
